import {
  AccountNumber,
  AccountType,
  Country,
  DefaultAccWithType,
} from '@/core/types';
import { createContext, PropsWithChildren } from 'react';

interface Props {
  accountTypes: AccountType[] | undefined;
  clientAccountNumbers: AccountNumber[] | undefined;
  defaultAccountNumbers: DefaultAccWithType[] | undefined;
  countries: Country[] | undefined;
}

export const COAContext = createContext({} as Props);

export const COAProvider = ({
  children,
  accountTypes,
  clientAccountNumbers,
  defaultAccountNumbers,
  countries,
}: PropsWithChildren<Props>) => {
  return (
    <COAContext.Provider
      value={{
        accountTypes,
        clientAccountNumbers,
        defaultAccountNumbers,
        countries,
      }}
    >
      {children}
    </COAContext.Provider>
  );
};
